import React from 'react';
import { motion } from 'framer-motion';
import { StethoscopeIcon, BrainIcon, GraduationCapIcon, HeartPulseIcon, ShieldCheckIcon, AwardIcon } from 'lucide-react';
export function Services() {
  const medicalServices = [{
    title: 'Family Practice & Lifestyle Wellness',
    items: ['Preventive care and wellness exams', 'Chronic disease management', 'Lifestyle counseling', 'Wellness planning']
  }, {
    title: 'Health Risk Assessments (HRAs)',
    items: ['Comprehensive health evaluations', 'Risk identification', 'Preventive planning']
  }, {
    title: 'Critical Care Consultation',
    items: ['Clinical consultation', 'Care coordination', 'Post-hospital recovery support']
  }, {
    title: 'Consultation & Training',
    items: ['Healthcare consultation', 'Mental wellness workshops', 'Organizational wellness programs']
  }];
  const mentalHealthServices = [{
    title: 'Family and Marriage Coaching',
    items: ['SYMBIS Marriage Facilitation', 'Couples Repair Specialist', 'Relationship restoration']
  }, {
    title: 'Trauma and PTSD Support',
    items: ['Trauma recovery', 'Emotional healing', 'PTSD support']
  }, {
    title: 'Mood Disorders Support',
    items: ['Anxiety and Depression support', 'Loneliness and Isolation support']
  }, {
    title: 'Specialized Coaching',
    items: ['Grief and Loss Support', 'Youth and Adolescent Coaching', 'Geriatric Mental Wellness', 'Life Recovery and Purpose Coaching']
  }];
  return <main className="bg-[#F5F2ED] py-20" data-id="element-355">
      <div className="container mx-auto px-4" data-id="element-356">
        <div className="text-center mb-16" data-id="element-357">
          <h1 className="text-5xl font-serif text-[#1B4332] mb-6" data-id="element-358">
            Our Comprehensive Services
          </h1>
          <p className="text-xl text-[#1A374D]/70 max-w-3xl mx-auto" data-id="element-359">
            Integrating primary healthcare and mental wellness to provide a
            holistic approach to your total well-being.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12" data-id="element-360">
          {/* Medical Services Column */}
          <div className="space-y-8" data-id="element-361">
            <div className="flex items-center gap-4 mb-8" data-id="element-362">
              <div className="w-12 h-12 bg-[#1B4332] rounded-xl flex items-center justify-center text-white" data-id="element-363">
                <StethoscopeIcon size={24} data-id="element-364" />
              </div>
              <h2 className="text-3xl font-serif text-[#1B4332]" data-id="element-365">
                Medical & Wellness
              </h2>
            </div>

            <div className="grid gap-6" data-id="element-366">
              {medicalServices.map((service, idx) => <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: idx * 0.1
            }} key={service.title} className="bg-white p-8 rounded-2xl shadow-sm border border-[#1B4332]/5" data-id="element-367">
                  <h3 className="text-xl font-bold text-[#1B4332] mb-4" data-id="element-368">
                    {service.title}
                  </h3>
                  <ul className="space-y-2" data-id="element-369">
                    {service.items.map(item => <li key={item} className="flex items-center gap-2 text-[#1A374D]/80" data-id="element-370">
                        <div className="w-1.5 h-1.5 rounded-full bg-[#B8860B]" data-id="element-371" />
                        {item}
                      </li>)}
                  </ul>
                </motion.div>)}
            </div>
          </div>

          {/* Mental Health Column */}
          <div className="space-y-8" data-id="element-372">
            <div className="flex items-center gap-4 mb-8" data-id="element-373">
              <div className="w-12 h-12 bg-[#B8860B] rounded-xl flex items-center justify-center text-white" data-id="element-374">
                <BrainIcon size={24} data-id="element-375" />
              </div>
              <h2 className="text-3xl font-serif text-[#1B4332]" data-id="element-376">
                Mental Health & Coaching
              </h2>
            </div>

            <div className="grid gap-6" data-id="element-377">
              {mentalHealthServices.map((service, idx) => <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: idx * 0.1
            }} key={service.title} className="bg-white p-8 rounded-2xl shadow-sm border border-[#1B4332]/5" data-id="element-378">
                  <h3 className="text-xl font-bold text-[#1B4332] mb-4" data-id="element-379">
                    {service.title}
                  </h3>
                  <ul className="space-y-2" data-id="element-380">
                    {service.items.map(item => <li key={item} className="flex items-center gap-2 text-[#1A374D]/80" data-id="element-381">
                        <div className="w-1.5 h-1.5 rounded-full bg-[#1B4332]" data-id="element-382" />
                        {item}
                      </li>)}
                  </ul>
                </motion.div>)}
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="mt-20 bg-[#1B4332] rounded-3xl p-12 text-center text-white" data-id="element-383">
          <h2 className="text-3xl font-serif mb-6" data-id="element-384">Not sure where to start?</h2>
          <p className="text-white/80 mb-8 max-w-2xl mx-auto" data-id="element-385">
            Schedule a consultation with our team to discuss your needs and
            develop a personalized restoration plan.
          </p>
          <button className="px-10 py-4 bg-[#B8860B] text-white font-bold rounded-full hover:bg-[#966d09] transition-all" data-id="element-386">
            Book a Consultation
          </button>
        </div>
      </div>
    </main>;
}